import { tsValidateArray, tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_ModifiableProps = {
    unitAsString: tsValidateString(),
    units: tsValidateArray(tsValidateString()),
    multiply: tsValidateArray(tsValidateString(), false),
    divide: tsValidateArray(tsValidateString(), false)
};
const Validator_GeneratedProps = {};
export const DBDef_MeasurementUnit = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'measurement-units',
    entityName: 'MeasurementUnit',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'measurement-unit'
    },
    backend: {
        name: 'measurement-units'
    },
};
//# sourceMappingURL=db-def.js.map